import styled, { css } from 'styled-components'
import Divider from 'components/Divider'
import { ContentBlockLoading } from 'components/ContentBlock'

export const StyledContentBlock = styled(ContentBlockLoading)`
	img {
		background: ${({ imgBackground }) => imgBackground ?? 'unset'};
	}
`

export const Label = styled.p`
    ${({ color }) => color && css`
    	color: ${color} !important;
    `};
	font-family: Roboto;
	font-size: ${({ fontSize }) => fontSize ?? '18px'};
	font-weight: ${({ fontWeight }) => fontWeight ?? 400};
	text-decoration-line: ${({ underline }) => underline ? 'underline' : 'unset'};
	align-self: ${({ alignSelf }) => alignSelf ?? 'unset'};
`

export const LinkContainer = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 15px;
	svg {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}
`

export const GoogleLabel = styled(Label)`
	font-family: Roboto;
	font-size: 12px;
	font-weight: 500;
`
export const GoogleValue = styled(Label)`
	font-family: Roboto;
	font-size: 11px;
	font-weight: 300;
`

export const StyledCardInfo = styled.div`
	background: ${({ theme }) => theme.darkbgColor};
	padding: 8px 12px;
	margin: 6px 0 30px 0;
	height: 100%;
	width: 100%;
	overflow: hidden;
	> div {
		background: #fff;
		min-height: 40px;
		padding: 5px 16px;
		> p:first-of-type {
			margin-bottom: 10px;

		}
	}
	> div ${Label} {
		color: #808080;
	}
	${Divider} {
		min-height: unset;
		padding: unset;
		background: ${({ theme }) => theme.darkbgColor};
		background: #fff !important;
    	width: 16px;
    	margin: 0;
	}
	
`

export const StyledCard = styled.div`
	display: flex;
	height: ${({ height }) => height}px;
	width: 300px;
	padding: 15px 15px;
	flex-direction: column;
	align-items: flex-start;
	border-radius: 20px;
	background: ${({ backgroundColor }) => backgroundColor};
	overflow: hidden;
	img {
		border-radius: 2px;
	}
	> svg {
		width: 127px;
		height: 127px;
		align-self: center;
		border-radius: 10px;
	}
	${Label} {
		margin: 0;
		color: #fff;
	}
	${Divider} {
		background: #808080
	}

`

export const StyledRow = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
`

export const QRContainer = styled.div`
	display: flex;
    background: #fff;
    flex-direction: column;
    align-self: center;
    padding: 0 5px 5px 5px;
    border-radius: 5px;
	p {
		margin-top: -10px !important;
	}
	> svg {
		width: 127px;
		height: 127px;
		align-self: center;
	}
`
